import {Component, OnInit} from '@angular/core';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {ImageUrls} from '../../../../shared/constants/ImageUrls';
import {MatDialogRef} from '@angular/material/dialog';
import {HttpClient, HttpEventType} from '@angular/common/http';
import {ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {FileTypes} from '../../../../shared/enums/res/FileTypes';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-upload-profile-picture',
  templateUrl: './upload-profile-picture.component.html',
  styleUrls: ['./upload-profile-picture.component.scss']
})
export class UploadProfilePictureComponent implements OnInit {

  acceptedFiles = GeneralConstant.ACCEPTED_PROFILE_IMAGE_FILES;
  fileUploadIcon = ImageUrls.ACCREDITATION.FILE_UPLOAD_ICON;

  constructor(private dialogRef: MatDialogRef<UploadProfilePictureComponent>, private httpClient: HttpClient) {
  }

  ngOnInit() {
  }

  /**
   * Cancel
   */
  cancel(): void {
    this.dialogRef.close();
  }

  onUploadProfile(event) {
    const addedFile = event.addedFiles[0];
    if (addedFile) {
      const formData = new FormData();
      formData.append('file', addedFile, addedFile.name);
      formData.append('data', `{"module": "${ApiEndpoints.ACCR.APPLICATION}", "resId": 1 ,"fileType": "${FileTypes.ALL_INVESTIGATION_FILES}"}`);
      this.httpClient.post(
        `${environment.api}/${environment.apiVersion}/${ApiEndpoints.FILE.FILE}/create/single_upload`,
        formData,
        {reportProgress: true, observe: 'events'}
      ).subscribe(ev => {
        if (ev.type === HttpEventType.Response) {
          this.dialogRef.close((ev.body as any).data);
        }
      });
    }
  }
}
